/* eslint-disable */
import qs from 'qs';
import changeCase from 'change-object-case';
import React, { Component } from 'react';
import { store } from '../store';
import { snakeKeys } from '../utils/util';


export default class OzComponent extends Component {

  componentWillMount() {
    let needs = this.constructor.need || [];

    needs.map(n => {
      console.log('NEED', n);

      let field = n[0];
      let fn = n[1];
      let argFn = null;
      if (n.length >= 3) {
        argFn = n[2]
      }
      let targetField = null;
      if (n.length >= 4) {
        targetField = n[3];
        field = targetField;
      }
      let prop = this.props[field];

      // console.log('::::: field', field, ':::::');
      // console.log('PROP _from', prop, (prop && prop._from));

      let shouldDispatch = !prop || Object.keys(prop).length == 0;

      // console.log('the argFn is', argFn);

      // Old had _from, new has no argFn, so should dispatch to load without filter
      if (prop && prop._from && !argFn) {
        shouldDispatch = true;
      }

      // Old had no _from, new does, so dispatch with filter
      if ((!prop || !prop._from) && argFn) {
        shouldDispatch = true;
      }

      // Both have filter, so compare them
      if (argFn && prop && prop._from) {
        let arg = argFn(this.props.params);
        // console.log('THE ARG IS', arg, typeof arg);
        if (typeof arg == 'object') {
          let ser = qs.stringify(snakeKeys(arg));
          // console.log('----');
          // console.log('CMP SER', field, prop._from, 'to', ser);
          // console.log('ARG', arg);
          // console.log('_from', prop._from);
          shouldDispatch = prop._from != ser;
        } else {
          shouldDispatch = prop._from != arg;
          // console.log('....');
          // console.log('CMP ARG', field, prop._from, 'to', arg);
          // console.log('should dispatch?', shouldDispatch);
        }
      }

      // console.log('SHOULD I DISPATCH?', shouldDispatch, n);

      if (shouldDispatch) {
        let dispatchPromise;
        if (argFn) {
          let args = argFn(this.props.params);
          let argsArr;
          if (Array.isArray(args)) {
            argsArr = args;
          } else {
            argsArr = [args];
          }
          console.log('==== CALL WITH ARG ARR', argsArr);
          dispatchPromise = store.dispatch(n[1].apply(n[1], argsArr));
            // .then((x) => {
            //   console.log('XXXXXXX', x);
            //   let y = Object.assign({}, x, {abc:'ABCCC'});
            //   store.dispatch(y);
            // });
        } else {
          dispatchPromise = store.dispatch(n[1]());
        }
        // dispatchPromise.then(action => {
        //   action = Object.assign({}, action);
        //   if (targetField) {
        //     action.targetField = targetField;
        //   }
        //   store.dispatch(action);
        // });
      }
    });
  }
}



/** WEBPACK FOOTER **
 ** ./src/lib/OzComponent.js
 **/